module.exports = __webpack_public_path__ + "static/payal_hero-caa745023c31bc9b0e9f3c44ff63cdb1.png";